import {useEffect, useState} from "react"
import {Diff2HtmlUIConfig} from "diff2html/lib/ui/js/diff2html-ui-slim.js"
import "diff2html/bundles/css/diff2html.min.css"
import "highlight.js/styles/github.css"
import * as Diff2Html from "diff2html"


/**
 * This viewer component parse standard diff output and visualizes the changes between differnt code trees
 * @param {{diffString: string}} param
 * @param param.diffString The standard diff output to be parsed
 * @returns
 */
const CodeDiffViewer: React.FC<{ diffString: string }> = ({diffString}) => {
  const [diff, setDiff] = useState<string>()

  useEffect(() => {
    const configuration: Diff2HtmlUIConfig = {
      matching: "lines",
      highlight: true,
      synchronisedScroll: true,
      outputFormat: "side-by-side"
    }
    const diffHtml = Diff2Html.html(
      diffString,
      configuration
    )

    setDiff(diffHtml)
  }, [diffString])

  if (!diff) {
    return null
  }

  return (
    <div dangerouslySetInnerHTML={{__html: diff}}>
    </div>
  )
}

export default CodeDiffViewer
